const FaqsDB = [
    {
        Question: 'Where is SLR Couture located?',
        Answer: 'SLR Couture is based in Seattle, WA. \nSLR Couture operates exclusively by appointment.  \n\n'
    },
    {
        Question: 'Do you have a storefront?',
        Answer: 'We do not have a physical retail space; our dresses are custom-made. You may choose from our online gallery or consult with our designer for a one-of-a-kind design.'
    },
    {
        Question: 'What is the best way to contact you?',
        Answer: 'The best way to reach us is via e-mail at slrcouture@gmail.com'
    },
    {
        Question: 'What are your starting prices?',
        Answer: 'Bridal - $5,000\nProm - $2,500\nSpecial Occasion - $1,500\nRTW - $1,200' 
    }, 
    {
        Question: 'Is there a consultation fee?',
        Answer: 'Consultation Fee:\nBridal - $250\nProm - $150\nSpecial Occasion - $150'
    },
    {
        Question: 'How is the consultation scheduling and cancellation handled?',
        Answer: "All consultations are by appointment only, and must be scheduled in advance.\n\n If you need to cancel or reschedule, please notify us in writing at least 72 hours in advance for a full refund, minus any transaction fees. Late cancellations are non-refundable and non-transferable, and a new appointment will need to be booked."
    }, 
    {
        Question:'What is your guest policy for appointments?',
        Answer: 'We recommend bringing no more than 2 guests for your initial consultation and fittings (Client +2).  Your appointment confirmation email will provide additional details and tips.'
    },
    {
        Question: 'Can I make changes to my dress design?',
        Answer: "Once production begins, design alterations cannot be accommodated. Any modifications must be finalized prior to the start of production."
    }, 
    {
        Question: 'How long does the bespoke couture process take?',
        Answer: 'Bridal Turnaround Timeframe 32-52 Weeks \n Prom Turnaround Timeframe 4-8 Weeks \n Special Occasion Turnaround Timeframe 4-6 Weeks \n '
    },
    {
        Question: 'Are there timeline recommendations?',
        Answer: 'When to Order: \n We advise booking your consultation at least 12 months in advance, with other dress orders ideally placed 8-12 months before your event.\n This allows ample time for fittings and any alterations.\n\n Production Timeframes: \n Bridal: 32-52 Weeks  \n Prom: 4 - 8 Weeks  \n Special Occasion: 4 - 6 Weeks' 
    }, 
    {
        Question: 'Do you offer express / rush services?',
        Answer: 'For WEDDING event deadlines within 4-6 months, express services are available at an additional 20% fee. Availability depends on the design and our production schedule.  Express Service Availability: Express orders for delivery within 12 weeks are available based on workshop capacity. This option incurs an additional fee and must be arranged prior to ordering. Note that express services are contingent on timely payments, fitting appointments, and client confirmations.\n \n For PROM event deadlines within 1 month, express services are available at an additional 20% fee. Availability depends on the design and our production schedule.  Express Service Availability: Express orders for delivery within 4 weeks are available based on workshop capacity. This option incurs an additional fee and must be arranged prior to ordering. Note that express services are contingent on timely payments, fitting appointments, and client confirmations.'
    },
    {
        Question: 'Do you offer couture bridal services internationally?',
        Answer: 'Yes, we do extend our couture services to international brides. Consultations will be held virtually via video call. At that time we will throughly discuss the entire couture process in detail.'
    },
    {
        Question: 'How long does shipping take?',
        Answer: "Domestic U.S. orders typically arrive within 5–7 business days. International orders arrive within 5–10 business days, depending on the destination."
    },
    {
        Question: 'Which carriers do you use?',
        Answer: 'All orders ship via UPS Ground or Canada Post. We do not ship to P.O. Boxes. Expedited shipping is available for an additional fee.'
    },
    {
        Question: 'Will I receive tracking information?',
        Answer: 'Yes. A shipping confirmation email with a tracking number will be sent once your order ships.'
    },
    {
        Question: 'Can changes be made after shipping?',
        Answer: 'Once your order leaves our showroom, we are unable to make changes, as delivery is handled by the carrier.'
    },
    {
        Question: 'Do you offer local pickup?',
        Answer: 'Yes. Seattle area clients may choose showroom pickup for dresses or have their order shipped.'
    },
    {
        Question: 'Are packages insured?',
        Answer: 'All shipped packages require a signature upon delivery. SLR Couture is not responsible for lost or stolen packages once released to the carrier. Shipping insurance is available upon request.'
    },
    {
        Question: 'What is your cancellation/refund policy?',
        Answer: "If you need to cancel your order, you can only do so providing your gown hasn’t begun production. \n \n There is a cancellation fee to cover the cost of administration, fabric allocation, pre-production and pattern preparation associated with your order. You must contact us immediately at slrcouture@gmail.com to discuss the circumstances surrounding the cancellation well in advance of your production date.  \n \n All custom made items are considered final sale and do not qualify for return, refund or store credits."
    }, 
    {
        Question: 'How do I care for/clean my dress?',
        Answer: "Each dress includes care instructions and dry-cleaning recommendations. \n \nWe recommend using specialized dry cleaners familiar with delicate fabrics and finishes to maintain the dress quality."
    }, 
    {
        Question: "What if my question wasn't answered/Need additional assistance?",
        Answer: "Still Have Questions? \n Email Us: slrcouture@gmail.com \n Call Us: 678-216-7719 \nWe aim to respond to all inquiries within 72 hours."
    }
    
    
    
    
];

export default FaqsDB